import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { FidelidadeService } from '../../_services/fidelidade.service';

import * as _ from 'lodash';
import { AuthService } from '../../_services/auth.service';

@Component({
  selector: 'app-experiencia-detalhe',
  templateUrl: './experiencia-detalhe.component.html',
  styleUrls: ['./experiencia-detalhe.component.scss'],
})
export class ExperienciaDetalheComponent implements OnInit {
  public experiencia: any = undefined;
  public membro: any = undefined;

  public carregandoExperiencia: boolean = false;
  public carregandoDescricao: boolean = false;
  public carregandoMembro: boolean = false;

  public regrasResgate: string[] = [];

  public mecanicaResgate: any[] = [];
  public observacoes: any[];
  public descricaoDetalhes: any[];

  public exibePopupGenerico: boolean = false;
  public tituloModalGenerico: string = '';
  public descricaoModalGenerico: string[] = [];

  public exibirModalLocalizacao: boolean = false;

  public mensagemVazia: any;

  public existeDetalhamentoMomentoEspecial: boolean = false;

  public nomeIdentificador: string = '';

  constructor(
    private fidelidadeService: FidelidadeService,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) {
    this.route.params.subscribe((params: any) => {
      try {
        const nomeIdentificador: string = params['nomeIdentificador'];

        if (!nomeIdentificador)
          throw 'Experiência não informada!';

        this.carregandoExperiencia = true;
        this.carregandoDescricao = true;
        this.nomeIdentificador = nomeIdentificador;
      } catch (ex) {
        console.warn('Não foi possível obter o id da experiência');
        this.router.navigate(['/index']);
      }
    });
  }

  ngOnInit(): void {
    this.carregarRegrasResgate();
    this.carregarMembroLogado();
  }

  private processarSucessoObterExperiencia(res: any): void {
    this.experiencia = res.resultado;
    this.carregandoDescricao = false;
    this.carregandoExperiencia = false;
    this.tratarListaMecanicaResgate();

    if (this.experiencia.detalhamentoMomentoEspecial == null || this.experiencia.detalhamentoMomentoEspecial == undefined || this.experiencia.detalhamentoMomentoEspecial == '')
      this.tratarListaObservacoesResgate();
    else
      this.existeDetalhamentoMomentoEspecial = true;

    this.tratarMensagemValidade();
  }

  private processarFalhaObterExperiencia(err: any): void {
    console.error('Ocorreu um erro ao obter a experiência', err);
    this.carregandoExperiencia = false;
  }

  private carregarRegrasResgate(): void {
    this.fidelidadeService
      .obterConfiguracaoPorDescricao('Texto_Regras_Resgate')
      .subscribe({
        next: (res: any) => (this.regrasResgate = res.valor.split(/\n/)),
        error: (err: any) =>
          console.error('Erro ao tentar buscar regras do resgate', err),
      });
  }

  private carregarMembroLogado(): void {
    this.carregandoMembro = true;

    var membro = this.authService.LocalStorage.obterMembro();
    this.processarSucessoObterMembro(membro);
  }

  private processarSucessoObterMembro(res: any): void {
    this.membro = res;
    this.carregandoMembro = false;

    if(this.nomeIdentificador != null && this.nomeIdentificador != '' && this.nomeIdentificador != undefined)
    {
      this.fidelidadeService
            .obterExperienciaPorNomeIdentificador(res.id, this.nomeIdentificador)
            .subscribe({
              next: (res: any) => this.processarSucessoObterExperiencia(res),
              error: (err: any) => this.processarFalhaObterExperiencia(err),
            });
    }
  }

  private processarFalhaObterMembro(err: any): void {
    console.error('Ocorreu um erro ao obter o membro', err);
    this.carregandoMembro = false;
  }

  public abrirPopupLocaisDisponiveis(exibir: boolean): void {
    this.exibirModalLocalizacao = exibir;
  }

  public obterMensagemResgate(): string {
    return (
      this.experiencia.mensagemResgate ??
      this.experiencia.mensagemResgateDefault
    );
  }

  public tratarListaMecanicaResgate() {
    let mecanicaResgate;

    if (this.experiencia.mecanicaResgate == undefined || this.experiencia.mecanicaResgate == null) {
      mecanicaResgate = _.filter(
        this.experiencia.experienciaTexto,
        (texto: any) => {
          return texto.titulo.toLowerCase().includes('mecânica de resgate');
        }
      );

      if (mecanicaResgate.length > 0) {
        const mecanicas = [];
        for (let i = 0; i < mecanicaResgate[0].experienciaParagrafo.length; i++) {
          let paragrafo = mecanicaResgate[0].experienciaParagrafo[i];
          paragrafo.descricao = paragrafo.descricao.split('\r').join('');

          if (paragrafo.descricao !== '') mecanicas.push(paragrafo);
        }
        let descricaoNumerada = mecanicas;

        for (let n = 0; n < descricaoNumerada.length; n++) {
          let novoParagrafo = descricaoNumerada[n].descricao;
          novoParagrafo = novoParagrafo;
          this.mecanicaResgate.push(novoParagrafo);
        }
      } else {
        this.mecanicaResgate = undefined;
      }
    }
    else {
      var div = document.createElement('div');
      div.innerHTML = this.experiencia.mecanicaResgate.replaceAll('<br>', String.fromCharCode(13));
      var textContent = div.textContent || div.innerText;
      var paragrafos = textContent.split("\n");

      if (paragrafos.length > 0) {
        for (let x = 0; x < paragrafos.length; x++) {
          if (paragrafos[x] != "") {
            let novoParagrafo = paragrafos[x];
            novoParagrafo = novoParagrafo;
            this.mecanicaResgate.push(novoParagrafo);
          }
        }
      }
      else
        this.mecanicaResgate = undefined;
    }

  }

  public tratarListaObservacoesResgate() {
    this.observacoes = _.filter(
      this.experiencia.experienciaTexto,
      (texto: any) => {
        return !texto.titulo.toLowerCase().includes('mecânica de resgate');
      }
    );
  }

  public tratarMensagemValidade() {
    this.mensagemVazia = this.experiencia.mensagemValidade;
    if (this.mensagemVazia == '') this.mensagemVazia = null;
  }

  public mostrarPopupRegulamentos() {
    this.fidelidadeService
      .obterConfiguracaoPorDescricao('regulamento')
      .subscribe(
        (sucesso) => {
          this.processarSucessoRegulamento(sucesso);
        },
        (falha) => {
          console.error('Ocorreu um erro ao tentar obter o regulamento', falha);
        }
      );
  }

  private processarSucessoRegulamento(response: any) {
    var linhas = response.valor.split('\n');

    for (let index = 1; index < linhas.length; index++) {
      if (linhas[index] == '\r') continue;

      this.descricaoModalGenerico.push(`${linhas[index]}<br><br>`);
    }

    this.exibePopupGenerico = true;
    this.tituloModalGenerico = linhas[0];
  }
}
